import { CardContent, Typography, Stack, Box, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import React, { useEffect, useState } from "react";
import { LineChart } from "@mui/x-charts/LineChart";
import { StyledCard } from "../../assets/styled-components/StyledCard";
import { getAuthToken, getFacilityId } from "../../utility/tokenUtility";
import { BemsGraph, FemsGraph, MasterGraph } from "../../utility/apiURLS";
import axios from "axios";
import commonMessages from "../../utility/constant";
import CustomSelectInput from "../commoncomponents/CustomSelectInput";
import { useNavigate } from "react-router-dom";

function Workorderstatusbyemployee() {
    const navigate = useNavigate();
    const [selectedType, setSelectedType] = useState("fems");
    const allMonths = commonMessages.months;
    const currentYear = new Date().getFullYear();
    const currentMonthIndex = new Date().getMonth();

    const [year, setYear] = useState({ label: currentYear.toString(), value: currentYear.toString() });
    const [month, setMonth] = useState(allMonths[currentMonthIndex]);
    const [monthsOptions, setMonthsOptions] = useState([]);
    const [yearsOptions, setYearsOptions] = useState([]);
    const [responseFememployee, setResponseFememployee] = useState([]);
    const [responseBememployee, setResponseBememployee] = useState([]);
    const handleRadioChange = (event) => setSelectedType(event.target.value);

    const fetchMaintenanceYears = async () => {
        const facilityid = localStorage.getItem("facilityId");
        try {
            const response = await axios.get(`${MasterGraph}/api/GraphMaintenanceYear/GetMaintenanceYearByFacilityId/${facilityid}?page=1&size=100`);
            const years = response.data.items.map(y => ({ label: y.maintyearvalue.toString(), value: y.maintyearvalue.toString() }));
            setYearsOptions(years);
        } catch (error) {
            console.error("Error fetching maintenance years:", error);
        }
    };

    const fetchDataWoEmployee = async () => {
        try {
            const token = getAuthToken("id_token");
            const facilityId = getFacilityId();
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            const [responseFem, responseBem] = await Promise.all([
                axios.get(`${FemsGraph}/api/FEMSDashboardWidgets/GetDashboardCountEmployee/${facilityId}/${year?.value}/${month?.id}`, config),
                axios.get(`${BemsGraph}/api/BEMSDashboardWidgets/GetDashboardCountEmployee/${facilityId}/${year?.value}/${month?.id}`, config),
            ]);

            setResponseFememployee(responseFem.data);
            setResponseBememployee(responseBem.data);

        } catch (error) {
            console.error("Error fetching Employee data:", error);
        }
    };

    useEffect(() => {
        const selectedYear = parseInt(year.value);
        const months =
            selectedYear === currentYear
                ? [...allMonths.slice(0, currentMonthIndex + 1)]
                : [...allMonths];

        setMonthsOptions(months);
        setMonth(selectedYear === currentYear ? allMonths[currentMonthIndex] : allMonths[0]);
    }, [year]);

    useEffect(() => {
        fetchMaintenanceYears();
        fetchDataWoEmployee();
    }, [year, month]);

    const handleYearChange = (newValue) => {
        setYear(newValue);
    };

    const handleMonthChange = (newValue) => {
        setMonth(newValue);
    };

    const combinedEmployees = selectedType === "fems" ? responseFememployee : responseBememployee;
    const employeeMap = new Map();

    combinedEmployees.forEach(emp => {
        const key = emp.employeename?.trim() || "Unknown";
        if (!employeeMap.has(key)) {
            employeeMap.set(key, {
                employeename: key,
                schCount: 0,
                unschCount: 0,
            });
        }
        const existing = employeeMap.get(key);
        existing.schCount += emp.schCount || 0;
        existing.unschCount += emp.unschCount || 0;
    });

    const employeeList = Array.from(employeeMap.values())
        .sort((a, b) => (b.schCount + b.unschCount) - (a.schCount + a.unschCount))
        .slice(0, 10);

    const chartData = employeeList.map(item =>
        item.employeename.length > 7 ? item.employeename.slice(0, 5) + '…' : item.employeename
    );

    const Scheduled = employeeList.map(item => item.schCount);
    const Unscheduled = employeeList.map(item => item.unschCount);

    const handleEmployeeChartClick = (event, d) => {
        if (d && d.dataIndex !== undefined) {
            const clickedEmployee = chartData[d.dataIndex];  // this should be the employee name or ID

            if (clickedEmployee) {
                navigate("/workorder", {
                    state: {
                        year: year?.value,
                        month: { value: month?.value, label: month?.label, id: month?.id },
                        employee: clickedEmployee   // you can pass employee name or ID here
                    }
                });
            }
        }
    };

    const fullEmployeeNames = employeeList.map(item => item.employeename);

    console.log("Full Employee Names:", fullEmployeeNames);

    return (
        <StyledCard variant="outlined">
            <CardContent>
                <Stack
                    direction="row"
                    spacing={1}
                    flexWrap="wrap"
                    useFlexGap
                    alignItems="center"
                    justifyContent="space-between"
                >
                    <Typography mb={1.5} variant="h5" fontWeight={650} color="text.primary">
                        Top 10 W.O Status Open by Employee
                    </Typography>
                    <Stack direction="row" alignItems="center" gap={1}>
                        <CustomSelectInput
                            fullWidth={false}
                            labelSize="14px"
                            sx={{ width: 100 }}
                            label="Year"
                            options={yearsOptions}
                            value={year}
                            onChange={handleYearChange}
                            placeholder="Select Year"
                            disableClearable
                            highlight
                        />
                        <CustomSelectInput
                            fullWidth={false}
                            labelSize="14px"
                            sx={{ width: 100 }}
                            label="Month"
                            options={monthsOptions}
                            value={month}
                            onChange={handleMonthChange}
                            placeholder="Select Month"
                            disableClearable
                            highlight
                        />
                    </Stack>
                </Stack>

                <Box mb={2}>
                    <RadioGroup
                        row
                        aria-labelledby="work-order-chart"
                        name="work-order-chart"
                        value={selectedType}
                        onChange={handleRadioChange}
                    >
                        <FormControlLabel value="fems" control={<Radio size="small" />} label="FEMS" />
                        <FormControlLabel value="bems" control={<Radio size="small" />} label="BEMS" />
                    </RadioGroup>
                </Box>

                <Box width="100%">
                    <LineChart
                        height={300}
                        xAxis={[{
                            data: fullEmployeeNames,
                            scaleType: "point",
                            label: "Employee", // just a string here
                            labelStyle: {
                                transform: "translateY(25px)",
                            },
                            tickLabelStyle: {
                                angle: -40,
                            },
                            valueFormatter: (value, context) => {
                                if (context?.location === 'tooltip') {
                                    return value;
                                }
                                return value.length > 7 ? value.slice(0, 5) + "…" : value;
                            },
                        }]}

                        yAxis={[{ label: "Work Orders", min: 0 }]}
                        series={[
                            { data: Scheduled, label: "Scheduled", color: "#4CAF50" },
                            { data: Unscheduled, label: "Unscheduled", color: "#62B5DD" },
                        ]}
                        margin={{ left: 80, bottom: 110 }}
                        slotProps={{ legend: { direction: "row", position: { vertical: "bottom", horizontal: "center" } } }}
                        onLineClick={handleEmployeeChartClick}
                        onAreaClick={handleEmployeeChartClick}
                        onMarkClick={handleEmployeeChartClick}
                    />

                </Box>
            </CardContent>
        </StyledCard>
    );
}

export default Workorderstatusbyemployee;
